// Two parallel zigzag lines rising to the right, like the logo mark
const ICON = String.raw`
                
             /  
    /\ /\   /  
   /  X  \ /  /
  /  / \  X \/
    /   \/
   /`

const WORDMARK = String.raw`
 _____ ___ _   _    _    ____  _____ ____ _  __
|  ___|_ _| \ | |  / \  |  _ \| ____/ ___| |/ /
| |_   | ||  \| | / _ \ | | | |  _|| |   | ' /
|  _|  | || |\  |/ ___ \| |_| | |__| |___| . \
|_|   |___|_| \_/_/   \_\____/|_____\____|_|\_\
`

// The art starts and may end on its own line, since a backslash right before the closing backtick would escape it
const toLines = (art: string) => art.split('\n').filter(line => line.length > 0)

/** Puts the icon to the left of the wordmark, with the wordmark vertically centered next to it. */
const sideBySide = (left: string, right: string, gap = 4) => {
  const leftLines = toLines(left)
  const rightLines = toLines(right)
  const width = Math.max(...leftLines.map(line => line.length)) + gap
  const offset = Math.floor((leftLines.length - rightLines.length) / 2)
  return leftLines.map((line, index) => (line.padEnd(width) + (rightLines[index - offset] ?? '')).trimEnd()).join('\n')
}

const LOGO = sideBySide(ICON, WORDMARK)

/** Greets developers who open the browser console. */
const logConsoleGreeting = () => {
  // eslint-disable-next-line no-console
  console.log(`%c\n${LOGO}\n`, 'color: #1677ff; font-family: monospace; font-weight: bold')
}

export default logConsoleGreeting
